import { StyleSheet, TextStyle } from 'react-native';
import fonts, { FontWeight } from 'src/themes/fonts';
import { theme } from 'src/themes/light';

export const getFontFamily = (weight: FontWeight): TextStyle => fonts[weight];

export default StyleSheet.create({
  common: {
    color: theme.colors.textDefault,
  },
  text: {
    fontSize: theme.fonts.text.fontSize,
    lineHeight: theme.fonts.text.lineHeight,
    letterSpacing: -0.2,
  },
  headline: {
    fontSize: theme.fonts.headline.fontSize,
    lineHeight: theme.fonts.headline.lineHeight,
    letterSpacing: -0.2,
  },
  subheading: {
    fontSize: theme.fonts.subheading.fontSize,
    lineHeight: theme.fonts.subheading.lineHeight,
  },
  title1: {
    fontSize: theme.fonts.title1.fontSize,
    lineHeight: theme.fonts.title1.lineHeight,
    letterSpacing: -0.8,
  },
  title2: {
    fontSize: theme.fonts.title2.fontSize,
    lineHeight: theme.fonts.title2.lineHeight,
    letterSpacing: -0.5,
  },
  title3: {
    fontSize: theme.fonts.title3.fontSize,
    lineHeight: theme.fonts.title3.lineHeight,
    letterSpacing: -0.2,
  },
  caption1: {
    fontSize: theme.fonts.caption1.fontSize,
    lineHeight: theme.fonts.caption1.lineHeight,
  },
  caption1Caps: {
    letterSpacing: 0.3,
  },
  caption2: {
    fontSize: theme.fonts.caption2.fontSize,
    lineHeight: theme.fonts.caption2.lineHeight,
  },
  caption2Caps: {
    letterSpacing: 0.3,
  },
  caption3: {
    fontSize: theme.fonts.caption3.fontSize,
    lineHeight: theme.fonts.caption3.lineHeight,
  },
  caption3Caps: {
    letterSpacing: 0.4,
  },
  caption4: {
    fontSize: theme.fonts.caption4.fontSize,
    lineHeight: theme.fonts.caption4.lineHeight,
  },
  caption4Caps: {
    letterSpacing: 0.5,
  },
});
